export {Text, type TextProps} from './Text';
